import styled from 'styled-components';

import { COUNTRY_DOMAINS } from '../../../common/constants';
import Container from '../../../components/Container';
import { getConfig } from '../../../config';
import { NAVBAR_LOGO_BASED_ON_COUNTRY } from '../Constants';

export const NavbarHeaderWithLogoContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 20px;
  width: 100%;
`;

export const NavbarLogo = styled.img.attrs({
  src:
    NAVBAR_LOGO_BASED_ON_COUNTRY[getConfig().COUNTRY] ??
    NAVBAR_LOGO_BASED_ON_COUNTRY[COUNTRY_DOMAINS.default],
  alt: 'Glints for Employers Logo',
})`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  margin-right: 10px;

  width: auto;
  height: 36px;
`;
